import React, {useContext} from "react"
import Typography from "../../reusable/Typography/Typography"
import Image from "next/image"
import {useRouter} from "next/router"
import BookAppointmentModalContent from "../../reusable/ModalsContent/BookAppointmentModalContent"
import {ModalContext} from "../../../context/ModalContext"
import LayoutContext from "../../../context/LayoutContext"
import {useTranslation} from "next-i18next"

function BrandWorldContactUs() {
	const {isMobile} = useContext(LayoutContext)
	const {t} = useTranslation(["common"])
	const router = useRouter()
	const {setModalContent, openModal, closeModal} = useContext(ModalContext)
	const bookAppointmentModalSetter = () => {
		setModalContent(<BookAppointmentModalContent closeModal={closeModal} />)
		openModal()
	}

	const contactUs = [{text: "send-us-through-whats", icon: "/assets/icons/whats-app-button-black-icon.svg", smallText: "most-popular-comm-channel-label", href: "https://api.whatsapp.com/send?phone=41435051318"},
		{text: "book-consultation", icon: "/assets/icons/calendar-consultation.svg", smallText: "talk-to-our-experts-card-desc", href: ""},
		{text: "email-us-label", icon: "/assets/envelope.svg", smallText: "email-us-desc-label", href: "mailto:sales@mybikeplan.ch"}]

	return (
		<div className="d-flex col-12 gap-0 align-items-center  justify-content-center flex-column">
			<Typography variant="bodyLgBlack"
				className="typography-amount "
				style={{textAlign: "center", marginBottom: "34px"}} >
				{t("contact-us")}
			</Typography>
			{contactUs.map(({text, icon, smallText, href}, index) => <div key={index}
				onClick={() => {
					if (index === 1) {
						bookAppointmentModalSetter()
					} else {
						router.push(href)
					}
				}}
				style={{
					cursor: "pointer",
					border: "solid 1px #212529",
					marginBottom: "-1px",
					padding: "48px 32px 32px 32px",
					borderTopLeftRadius: index === 0 ? "16px" : "",
					borderTopRightRadius: index === 0 ? "16px" : "",
					gap: "8px",
					borderBottomRightRadius: index === 2 ? "16px" : "",
					borderBottomLeftRadius: index === 2 ? "16px" : ""
				}}
				className="col-10 position-relative d-flex align-items-center justify-content-center">
				<Typography variant="bodySm"
					style={{fontSize: "12px", lineHeight: "16px", whitespace: "nowrap", position: "absolute", left: "50%", transform: "translate(-50%)", marginTop: "10px"}}
					className="top-0">{t(text)}</Typography>
				<Image src={icon}
					width={40}
					height={40} />
				<Typography variant="bodySm"
					className="whitespace-nowrap"
					semanticTag="span"
					style={{fontSize: isMobile ? "20px" : "40px", lineHeight: isMobile ? "28px" : "48px"}}>{t(text)}</Typography>
			</div>)}
		</div>
	)
}

export default BrandWorldContactUs
